import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useLang } from "@/contexts/LangContext";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 md:px-12 py-24 fade-in" data-testid="forgot-password-page">
      <p className="tracking-eyebrow text-[var(--eafg-muted)]">{t("auth.forgotSubtitle")}</p>
      <h1 className="font-serif-display text-5xl mt-3 mb-10">{t("auth.forgotTitle")}</h1>

      {sent ? (
        <div className="space-y-6" data-testid="forgot-sent">
          <p className="text-[var(--eafg-ink)]">{t("auth.forgotSent")}</p>
          <Link to="/login" className="inline-block border border-[var(--eafg-ink)] px-6 py-3 tracking-eyebrow hover:bg-[var(--eafg-ink)] hover:text-white">
            {t("auth.submitLogin")}
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-6" data-testid="forgot-form">
          <label className="block">
            <span className="tracking-eyebrow text-[var(--eafg-muted)] block mb-2">{t("auth.email")}</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border-b border-[var(--eafg-line)] bg-transparent py-2 focus:outline-none focus:border-[var(--eafg-ink)]"
              data-testid="forgot-email"
            />
          </label>
          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-[var(--eafg-ink)] text-white py-4 tracking-eyebrow hover:bg-[var(--eafg-copper)] disabled:opacity-50"
            data-testid="forgot-submit"
          >
            {t("auth.forgotSubmit")}
          </button>
          <p className="text-sm text-[var(--eafg-muted)]">
            <Link to="/login" className="underline hover:text-[var(--eafg-copper)]">
              {t("auth.submitLogin")}
            </Link>
          </p>
        </form>
      )}
    </div>
  );
}
